var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-content-center" }, [
    _c(
      "div",
      { staticClass: "variable-wrap" },
      [
        _c("div", { staticClass: "card-content card-variable" }, [
          _c("div", { staticClass: "title-with-add" }, [
            _c("p", { staticClass: "card-title" }, [_vm._v("Variables")]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "btn-add",
                on: {
                  click: function($event) {
                    _vm.openModalAdd()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Add\n        ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-variable" },
            _vm._l(_vm.dummyData, function(data, index) {
              return _c(
                "div",
                { key: "variable-" + index, staticClass: "variable" },
                [
                  _c("div", { staticClass: "left-section" }, [
                    _c("img", {
                      staticClass: "variable-icon",
                      attrs: {
                        src: require("@/assets/app-manager/icon/variable-icon.svg"),
                        alt: "variable-icon"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "variable-name" }, [
                      _vm._v(_vm._s(data.name))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "variable-value ellipsis" }, [
                      _vm._v(_vm._s(data.value))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right-section" }, [
                    _c("i", {
                      staticClass: "fa fa-pencil-square-o edit-variable",
                      on: {
                        click: function($event) {
                          _vm.openModalAdd(data)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-trash delete-variable" })
                  ])
                ]
              )
            })
          )
        ]),
        _vm._v(" "),
        _vm.isOpenModalAdd
          ? _c("modal-variable", {
              attrs: { id: _vm.idModalAdd, "data-variable": _vm.dataModalAdd },
              on: {
                "close-modal": function($event) {
                  _vm.toggleModalAdd(false)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b6b98b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6b98b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/jVariablesTab.vue
// module id = null
// module chunks = 